import { useEffect, useRef, useState } from "react";
import Gallery from "../../../../properties/panel/Gallery";
import PanelBody from "../../../../properties/panel/PanelBody";
import Thumbs from "../../../../properties/partials/Thumbs";
import Checkers from "../../../../../../helpers/class/Checkers";

export default function BedroomCard(props) {

  useEffect(() => {
    if (document !== undefined) {
      const dynamicBullets = document.querySelectorAll('.swiper-pagination-bullets-dynamic');
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      //@ts-ignore
      for (const dynamicBullet of dynamicBullets) {
        dynamicBullet.style.display = 'flex';
        dynamicBullet.style.paddingBottom = '.2rem';
      }
      const nextButtons = document.querySelectorAll('.swiper-custom-next');
      if (nextButtons) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        for (const nextButton of nextButtons) {
          nextButton.addEventListener('click', function (e) {
            e.preventDefault()
            e.stopPropagation();
          })
        }
      }
      const prevButtons = document.querySelectorAll('.swiper-custom-prev');
      if (nextButtons) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        for (const prevButton of prevButtons) {
          prevButton.addEventListener('click', function (e) {
            e.preventDefault()
            e.stopPropagation();
          })
        }
      }
    }
  })

  return (
    <>
      <div>
        <div onClick={props.handleShow} className="cursor-pointer">
          <Gallery
            key={"thumbs-gallery-swiper-" +props.bedroom_id}
            property_id={props.bedroom_id}
            images={props.images}
            isHotel={true}
          />
        </div>
        <div className="text-left">
          <PanelBody
            handleShow={props.handleShow}
            property_id={props.bedroom_id}
            property_title={props.bedroom_title}
            bedrooms={props.bedrooms}
            complexCount={props.complexCount}
            bodyHrefClass={'mt-auto'}
            property_moto={props.description}
            isHotel={true}
            bedroom_prices={props.prices}
          />
        </div>
      </div>
    </>
  );
}
